import { paths } from './paths'

export const piecesLinks = {
  incomingPiecesLink: () => `/${paths.INCOMING}`,
  outgoingPiecesLink: () => `/${paths.OUTGOING}`,
}
